import React, { PureComponent } from 'react';
import Plot from 'react-plotly.js';
import { Statistic, Grid, Divider, Segment } from 'semantic-ui-react';
import _ from 'lodash';

const colorList = [
  '#2ca02c', // cooked asparagus green
  '#1f77b4', // muted blue
  '#9467bd', // muted purple
  '#ff7f0e', // safety orange
  '#d62728', // brick red
  '#ff1114', // red
  '#ff0000', // chestnut brown
  '#e377c2', // raspberry yogurt pink
  '#7f7f7f', // middle gray
  '#bcbd22', // curry yellow-green
  '#17becf', // blue-teal
];

export default class UtilizationSunburst extends PureComponent {
  render() {
    const { data } = this.props;
    const processedData = Object.assign(
      {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
      },
      _.countBy(data),
    );
    const ordered = {};
    Object.keys(processedData)
      .sort()
      .forEach(function(key) {
        ordered[key] = processedData[key];
      });
    return (
      <Segment basic>
        <Grid columns={3} divided>
          <Grid.Row>
            <Grid.Column width={7}>
              <Plot
                config={{
                  displayModeBar: false,
                }}
                data={[
                  {
                    values: [
                      data.length > 24 ? data.length : 24,
                      (data.length > 24 ? data.length : 24) - data.length,
                      data.length,
                      ...Object.values(ordered),
                    ],
                    labels: [
                      'Slots',
                      'Empty Slots',
                      'Occupied Slots',
                      ...Object.keys(ordered).map(k => '#Students: ' + k),
                    ],
                    marker: {
                      colors: [
                        '#dddddd',
                        '#bcbd22',
                        '#1f77b4',
                        ...Object.keys(ordered).map(k => colorList[k]),
                      ],
                      line: {
                        width: 2,
                      },
                    },
                    outsidetextfont: { size: 20, color: '#377eb8' },
                    parents: [
                      '',
                      'Slots',
                      'Slots',
                      ...Object.keys(ordered).map(d => 'Occupied Slots'),
                    ],
                    type: 'sunburst',
                    sort: false,
                    hoverinfo: 'label+text+value',
                    textinfo: 'none',
                    branchvalues: 'total',
                  },
                ]}
                layout={{
                  height: 140,
                  width: 150,
                  margin: {
                    l: 10,
                    r: 10,
                    b: 10,
                    t: 10,
                    pad: 5,
                  },
                  annotations: [
                    {
                      font: {
                        size: 13,
                        color: '#1f77b4',
                      },
                      showarrow: false,
                      text:
                        data.length > 0
                          ? (100 * (_.sum(data) / 108.0)).toFixed(0) + '%'
                          : 'NA',
                      x: 0.5,
                      y: 0.5,
                    },
                  ],
                  plot_bgcolor: 'rgba(0,0,0,0)',
                  paper_bgcolor: 'rgba(0,0,0,0)',
                  showlegend: false,
                }}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Statistic size="mini">
                <Statistic.Label>
                  Time <br /> Utilization
                </Statistic.Label>
                <Statistic.Value>
                  {((data.length * 100) / 24.0).toFixed(1)}%
                </Statistic.Value>
              </Statistic>
              <Divider />
              <Statistic size="mini">
                <Statistic.Label>
                  Current # <br /> of Classes
                </Statistic.Label>
                <Statistic.Value>{data.length}</Statistic.Value>
              </Statistic>
            </Grid.Column>
            <Grid.Column width={4}>
              <Statistic size="mini">
                <Statistic.Label>
                  Student <br />
                  Utilization
                </Statistic.Label>
                <Statistic.Value>
                  {data.length
                    ? ((_.sum(data) * 100) / (6.0 * data.length)).toFixed(1)
                    : 'NA'}
                  %
                </Statistic.Value>
              </Statistic>
              <Divider />
              <Statistic size="mini">
                <Statistic.Label>
                  # Vacant <br /> Slots
                </Statistic.Label>
                <Statistic.Value>{6.0 * data.length - _.sum(data)}</Statistic.Value>
              </Statistic>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}
